import getSites from './sites';
import getSitesStatus from './sites-status';

export default {
  getSites,
  getSitesStatus,
};
